import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

const APPS = [
    { id: 'supermath', label: 'SuperMath' },
    { id: 'leonora', label: "Leonora's Colors" },
];

const PrivacyPolicy = ({ onBack }) => {
    const [activeApp, setActiveApp] = useState('supermath');

    return (
        <div className="legal-page">
            <div className="legal-container">
                <button className="legal-back" onClick={onBack}>
                    <ArrowLeft size={20} />
                    Back to Home
                </button>

                <h1>Privacy Policy</h1>

                <div className="legal-tabs">
                    {APPS.map((app) => (
                        <button
                            key={app.id}
                            className={`legal-tab ${activeApp === app.id ? 'active' : ''}`}
                            onClick={() => setActiveApp(app.id)}
                        >
                            {app.label}
                        </button>
                    ))}
                </div>

                {activeApp === 'supermath' && (
                    <div className="legal-iframe-wrapper">
                        <iframe
                            src="https://supermathapp.com/privacy"
                            title="SuperMath Privacy Policy"
                            className="legal-iframe"
                        />
                    </div>
                )}

                {activeApp === 'leonora' && (
                    <>
                        <p className="legal-updated">Last Updated: February 5, 2026</p>

                        <p>
                            This policy applies to the <strong>Leonora's Colors</strong> application.
                            Our top priority is protecting children's privacy. The App is built on "Privacy by Design"
                            principles to minimize data processing.
                        </p>

                        <h2>1. No Personal Data Collection</h2>
                        <p>
                            The Application <strong>does NOT collect</strong>, store, or share any Personally Identifiable
                            Information (PII) such as Name, Surname, Email Address, Phone Number, or precise GPS Location.
                            No account registration is required to use the app.
                        </p>

                        <h2>2. No Advertising or Tracking</h2>
                        <p>
                            Leonora's Colors does not contain any third-party advertising banners, commercial tracking tools,
                            or analytics services that collect user data. The app is completely ad-free.
                        </p>

                        <h2>3. No In-App Purchases</h2>
                        <p>
                            The app does not offer in-app purchases. All content is available at no additional cost after
                            the initial download.
                        </p>

                        <h2>4. Data Storage</h2>
                        <p>
                            All game progress is stored locally on the device. No data is transmitted to external servers.
                            Uninstalling the app will remove all locally stored data.
                        </p>

                        <h2>5. Third-Party Services</h2>
                        <p>
                            The app does not integrate with any third-party services that collect personal data.
                            No social media integrations, no cloud storage, no analytics.
                        </p>

                        <h2>6. Contact for Parents</h2>
                        <p>
                            For any questions regarding children's privacy, parents or guardians can contact us
                            at: <strong>privacy@eagletap.com</strong>.
                        </p>
                    </>
                )}
            </div>
        </div>
    );
};

export default PrivacyPolicy;
